import AccordionBlock from './AccordionBlock';
export type { AccordionBlockProps } from './AccordionBlock.d';

export default AccordionBlock;
